/* eslint-disable max-lines */
/* eslint-disable complexity */
/* eslint-disable import/no-unresolved */
import React from 'react';
import type { RefCallback } from 'react';
import { PropTypes, describe } from '@elliemae/ds-props-helpers';
import { Grid } from '@elliemae/ds-grid';
import { styled, truncate } from '@elliemae/ds-system';
import { GroupItem } from '@elliemae/ds-shared';
import { DSCheckbox } from '@elliemae/ds-legacy-form';
import { Checkmark } from '@elliemae/ds-icons';
import { DSMobileTouchable } from '../MobileTouchable/index.js';

const Wrap = styled((props) => <DSMobileTouchable {...props} />)`
  border-bottom: none;
`;

const PropWrap = styled((props) => <Grid {...props} />)`
  ${(props) => {
    if (!props.isMulti) {
      return `
      & > span {
        height: 18px;
        width: 18px;
      }

      & > span > svg {
        height: 18px;
        width: 18px;
      }
      `;
    }
    return '';
  }}
`;

const Title = styled.span`
  font-size: 16px;
  color: ${(props) => props.theme.colors.brand['600']};
  ${truncate()}
`;

const Label = styled.span`
  font-size: 13px;
  color: ${(props) => props.theme.colors.neutral['600']};
`;

const CheckMark = styled(Checkmark)`
  fill: ${(props) => props.theme.colors.brand['600']};
`;
interface DSMobileContextMenuItemPropsT {
  label: string;
  title: string;
  leftProp: JSX.Element;
  isGroup: boolean;
  isMulti: boolean;
  isSelected: boolean;
  singleSelect: boolean;
  onClick: (e: any) => void;
  value: string;
  innerRef: React.MutableRefObject<HTMLButtonElement | null> | RefCallback<HTMLButtonElement>;
}
const DSMobileContextMenuItem = ({
  label,
  title,
  leftProp,
  rightAddon,
  isGroup,
  isMulti,
  singleSelect,
  isSelected,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick = () => {},
  value,
  innerRef,
}: DSMobileContextMenuItemPropsT): JSX.Element => (
  <GroupItem
    render={(context) => {
      const { activeValue } = context;
      let someItemSelected = activeValue >= 0 && !Array.isArray(activeValue);
      if (isGroup) someItemSelected = typeof activeValue === 'string';

      let showLeftAddon = isSelected;
      if (isMulti || !singleSelect) showLeftAddon = true;

      let leftAddon = leftProp || null;
      if (isMulti) leftAddon = <DSCheckbox checked={isSelected} data-testid="leftAddon-checkbox" />;
      if (singleSelect) leftAddon = <CheckMark data-testid="leftAddon-checkmark" />;

      console.log('SSS', innerRef);
      const cols =
        (singleSelect && someItemSelected) || (leftAddon && !singleSelect) || isMulti ? ['40px', 'auto'] : ['auto'];
      if (rightAddon) cols.push('40px');
      return (
        <Wrap
          data-testid="ds-contextmenu-item"
          onClick={(e) => {
            if (singleSelect || isMulti) context.onChange(value, e, { value, label, title });
            onClick(e);
          }}
          cols={cols}
          innerRef={innerRef}
        >
          {((singleSelect && someItemSelected) || isMulti || leftAddon) && (
            <PropWrap data-testid="left-addon" isMulti={isMulti} alignItems="center" justifyContent="center" pl="16px">
              {showLeftAddon && leftAddon}
            </PropWrap>
          )}
          <Grid height="44px" pr="xs" pl={!leftAddon && isGroup ? '24px' : 'xs'}>
            {label && (
              <Grid alignItems="center">
                <Label data-testid="contextMenuItem-label">{label}</Label>
              </Grid>
            )}
            <Grid alignItems={!label ? 'center' : undefined}>
              <Title data-testid="contextMenuItem-title">{title}</Title>
            </Grid>
          </Grid>
          {rightAddon ? (
            <PropWrap data-testid="right-addon" alignItems="center" justifyContent="center">
              {rightAddon}
            </PropWrap>
          ) : null}
        </Wrap>
      );
    }}
  />
);

const props = {
  /** label */
  label: PropTypes.string.description('label'),
  /** menu item title */
  title: PropTypes.string.isRequired.description('menu item title'),
  /**  */
  leftProp: PropTypes.element.description(''),
  /** multi select */
  isMulti: PropTypes.bool.description('multi select'),
  /**  */
  singleSelect: PropTypes.bool.description(''),
  /**  */
  isGroup: PropTypes.bool.description(''),
  /** on click handler */
  onClick: PropTypes.func.description('on click handler'),
  /** value for select */
  value: PropTypes.number.description('value for select'),
  /** selected value */
  isSelected: PropTypes.bool.description('selected value'),
  /**  */
  innerRef: PropTypes.any.description('Ref for the item'),
};

DSMobileContextMenuItem.displayName = 'DSMobileContextMenuItem';
const DSMobileContextMenuItemWithSchema = describe(DSMobileContextMenuItem);

DSMobileContextMenuItemWithSchema.propTypes = props;

export { DSMobileContextMenuItem, DSMobileContextMenuItemWithSchema };
